export default __webpack_public_path__ + "static/media/1880.a780d43f.png";